import type { Product } from '../types';

type ProductLimits = {
	licensedUserLimit: number;
	warningUserLimit: number;
};

// TODO: `licensedUserLimit` should be fetched from the server
export const PRODUCT_LIMITS_MAP: Record<Product, ProductLimits> = {
	'jira-product-discovery': {
		licensedUserLimit: 3,
		warningUserLimit: 2,
	},
	jira: {
		licensedUserLimit: 10,
		warningUserLimit: 7,
	},
	confluence: {
		licensedUserLimit: 10,
		warningUserLimit: 3,
	},
	'jira-service-management': {
		licensedUserLimit: 3,
		warningUserLimit: 2,
	},
	'jira-customer-service': {
		licensedUserLimit: 3,
		warningUserLimit: 2,
	},
};
